import { render, staticRenderFns } from "./ShowArticle.vue?vue&type=template&id=9a550538"
import script from "./ShowArticle.vue?vue&type=script&lang=js"
export * from "./ShowArticle.vue?vue&type=script&lang=js"
import style0 from "./ShowArticle.vue?vue&type=style&index=0&id=9a550538&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_css-loader@6.11.0_webpack@5.96.1__lodash@4.17.21__2dnwv33wcshjexuxr5fqoigkvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports